import {MessagePatch} from '../helpers/models/messagePatchHelpers';
import {AnnotationModel} from '../models/api/annotationModel';

/*
 * Types + Collection.
 */

export interface MessageComposerApi {
  focus(): void;
  insertHtml(html: string): void;
  insertSubject(value: string): void;
  setHtml(html: string): void;
  setSubject(value: string): void;
  saveMessage(messagePatch: MessagePatch): void;
}

export interface CommentComposerApi {
  focus(): void;
  setReferencedActivity(id: number | null): void;
  setAnnotation(annotation: AnnotationModel | null, activityId?: number): void;
}

type MessageComposers = {[T: string]: MessageComposerApi | undefined};
const messageComposers: MessageComposers = {};

type CommentComposers = {[T: number]: CommentComposerApi | undefined};
const commentComposers: CommentComposers = {};

/*
 * API.
 */

export function registerMessageComposer(messageUid: string, composer: MessageComposerApi) {
  messageComposers[messageUid] = composer;
  return () => {
    if (messageComposers[messageUid] !== composer) {
      return;
    }

    delete messageComposers[messageUid];
  };
}

export function findMessageComposer(messageUid: string) {
  return messageComposers[messageUid];
}

export function registerCommentComposer(conversationId: number, composer: CommentComposerApi) {
  commentComposers[conversationId] = composer;
  return () => {
    if (commentComposers[conversationId] !== composer) {
      return;
    }

    delete commentComposers[conversationId];
  };
}

export function findCommentComposer(conversationId: number) {
  return commentComposers[conversationId];
}
